import React from 'react';
import PropTypes from 'prop-types';

import './form_layout.css';

// Building blocks for the shared pop-up form layout (see form_layout.css).

export function FormSection({ title, children, className }) {
  return (
    <section className={`myt-form-section ${className}`.trim()} aria-label={title || undefined}>
      {title ? <div className="myt-form-section-title">{title}</div> : null}
      {children}
    </section>
  );
}

FormSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

FormSection.defaultProps = { title: '', children: null, className: '' };

// The action row: right-aligned on desktop, full-width stacked on phones, pinned while the body scrolls.
export function FormActions({ children }) {
  return <div className="myt-form-actions">{children}</div>;
}

FormActions.propTypes = { children: PropTypes.node };
FormActions.defaultProps = { children: null };

export function FormHelp({ children, id }) {
  return (
    <p className="myt-form-help" id={id}>
      {children}
    </p>
  );
}

FormHelp.propTypes = { children: PropTypes.node, id: PropTypes.string };
FormHelp.defaultProps = { children: null, id: undefined };
